<template>
  <div class="common-project">
    <div class="common-project-title">
      <img :src="iconName" alt="" />
      <h1>{{categoryTitle}}</h1>
    </div>
    <div class="common-project-content" v-if="categoryTitle !== '三维设计'">
      <div class="list" v-if="itemData.length > 0">
        <div class="item-parent">
          <div v-for="(value, index) in itemData" :key="value.id" class="item-child" :class="{'listSpecial': categoryTitle === '电商设计' && index === 4}">
            <div @click="goDetails(value)" v-track="[ value.name, '文字点击' ]">
              <div class="divImg">
                <img src="@/assets/cover.jpg" v-if="value.logoImage === null || value.logoImage === ''"/>
                <img v-lazy="{ src: value.logoImage.url, loading: require('@/assets/coverpic.jpg') }" v-else/>
              </div>
              <div class="back-p">
                <p>
                  <span v-if="value.trade !== null">
                    <span class="fontBg" :style="{ background: '#ebeff5', color: '#333' }"
                      v-if="value.trade.color === null || value.trade.color == ''">{{ value.trade.name }}</span>
                    <span style="background: #fff;" class="fontBg" v-else>{{ value.trade.name }}</span>
                  </span>
                  {{ value.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="categoryTitle === '三维设计'" class="three-dimension" >
      <div v-for="value in itemData" :key="value.id">
        <div class="back-content" @click="goDetails(value)" v-track="[ value.name, '文字点击' ]">
          <div class="divImg">
            <img src="@/assets/cover.jpg" v-if="value.logoImage === null || value.logoImage === ''"/>
            <img v-lazy="{ src: value.logoImage.url, loading: require('@/assets/coverpic.jpg') }" v-else/>
          </div>
          <div class="back-p">
            <p>
              <span v-if="value.trade !== null">
                <span class="fontBg" :style="{ background: '#ebeff5', color: '#333' }"
                  v-if="value.trade.color === null || value.trade.color == ''">{{ value.trade.name }}</span>
                <span style="background: #fff;" class="fontBg" v-else>{{ value.trade.name }}</span>
              </span>
              {{ value.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    categoryTitle: {
      type: String,
      required: true,
      default: "UI设计"
    },
    itemData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      newiconName: this.categoryTitle
    }
  },
  computed: {
    iconNameCommon () {
      return this.columnObj
    }
  },
  watch: {
    newiconName: {
      handler (val) {
        if (val === "UI设计") {
          this.iconName = require("../designImg/ui.png")
        } else if (val === "电商设计") {
          this.iconName = require("../designImg/dianshang.png")
        } else if (val === "平面设计") {
          this.iconName = require("../designImg/pinpai.png")
        } else {
          this.iconName = require("../designImg/sanwei.png")
        }
      },
      immediate: true
    }
  },
  methods: {
    goDetails (value) {
      window.sessionStorage.setItem("detailsId", String(value.id))
      let routerData
      if (value.router) {
        routerData = this.$router.resolve({
          path: value.router
        })
      } else if (value.p_template && value.p_template.code) {
        routerData = this.$router.resolve({
          path: "/" + value.p_template.code
        })
      } else {
        routerData = this.$router.resolve({
          path: "/details"
        })
      }
      window.open(routerData.href, "_blank")
    }
  },
}
</script>

<style lang="scss" scoped>
  .common-project {
    min-width: 1200px;
    margin: 0 auto;
    // padding-bottom: 32px;
    padding-top: 34px;
    width: 100%;
    // 去掉原因加了背景
    // background-color: #FBFCFD;
    .common-project-title {
      width: 100%;
      text-align: center;
      img {
        width: 21px;
        height: 20px;
        vertical-align: middle;
        color: #ccc;
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 6px;
      }
      h1 {
        display: inline-block;
        text-align: center;
        font-size: 20px;
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
        font-weight: 600;
        line-height: 45px;
        color: #1286FF;
      }
    }
    .common-project-content {
      .list {
        max-width: 1200px;
        margin: 0 auto;
        margin-top: 32px;
        overflow: hidden;
        .item-parent {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: space-between;
          .item-child {
            position: relative;
            box-sizing: border-box;
            width: 291px;
            height: 238px;
            padding-bottom: 20px;
            margin-bottom: 8px;
            margin-right: 8px;
            border: 0 solid #dcdee3;
            box-shadow: 0 2px 14px 0 rgba(0,0,0,.1);
            background: #fff;
            transition: all 0.8s;
            cursor: pointer;
            overflow: hidden;
            .divImg {
              text-align: center;
              width: 100%;
              height: 100%;
              img {
                width: 291px;
                height: 238px;
                transition: all 0.8s;
              }
            }
            .back-p {
              line-height: 40px;
              padding: 0 8px 10px 16px;
              box-sizing: border-box;
              display: block;
              position: absolute;
              width: 100%;
              bottom: 40px;
              height: auto;
              background-color: rgba(0, 0, 0, 0.3);
              transition: all 0.25s;
              transform: translateY(100%);
              color: #fff;
              font-size: 14px;
              text-align: left;
              p {
                font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
                color: #fff;
              }
            }
            &:hover img {
              transform: scale(1.1);
              transition: all 0.8s;
            }
          }
          .listSpecial {
            width: 591px;
            height: 238px;
            .divImg {
              width: 594px;
              height: 238px;
              img {
                display: block;
                width: 594px;
                height: 238px;
              }
            }
          }
        }
        .item-parent:after{
          content: '';
          width: 24%;
        }
      }
    }
    .three-dimension {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      height: 400px;
      margin-top: 40px;
      margin-bottom: 72px;
      .back-content {
        cursor: pointer;
        height: 100%;
        img {
          transition: all 0.8s;
          width: 100%;
          height: 400px;
        }
        .back-p {
          display: none;
          line-height: 40px;
          padding: 0 8px 10px 16px;
          box-sizing: border-box;
          display: block;
          position: absolute;
          width: 100%;
          bottom: 40px;
          height: auto;
          background-color: rgba(0, 0, 0, 0.3);
          transition: all 0.25s;
          transform: translateY(100%);
          color: #fff;
          font-size: 14px;
          text-align: left;
          p {
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            color: #fff;
            span {
              .fontBg {
                background-color: #fff;
                color: #000;
              }
            }
          }
        }
      }
      .back-content:hover img {
        transform: scale(1.1);
        transition: all 0.8s;
      }
      
    }
  }
</style>